import { apiPath } from './api.path';
import { instance } from './axios';

async function getAntibioticAPI() {
  return instance.get(apiPath.getAntibiotic).then((response) => response.data);
}

const antibioticService = {
  getAntibioticAPI
};
export default antibioticService;
